import { RootState, SetState } from '@/store/useStore.ts';
import {
  CommonUIErrorPayload,
  CommonUIPayload,
  CommonUiSlice,
  defaultCommonUIState,
} from '@/store/slices/commonUi/types';
import { emptySliceError } from '../sliceError';

export type { GameHelpItem } from '@/store/slices/commonUi/types';

export const commonUiSlice = ({ set }: SetState<RootState>): CommonUiSlice => ({
  commonUIContext: { ...defaultCommonUIState },
  commonUIError: emptySliceError(),
  setCommonUIContext: (newState: CommonUIPayload) =>
    set(
      (state: RootState) => ({
        ...state,
        commonUIContext: { ...state.commonUIContext, ...newState },
      }),
      false,
      'commonUi/setCommonUi',
    ),

  setCommonUIError: (newState: CommonUIErrorPayload) =>
    set(
      (state: RootState) => ({
        ...state,
        commonUIError: {
          ...state.commonUIError,
          ...newState,
        },
      }),
      false,
      'commonUi/setCommonUiError',
    ),

  resetCommonUIContext: () =>
    set(
      () => ({ commonUIContext: { ...defaultCommonUIState } }),
      false,
      'commonUi/resetCommonUi',
    ),
});
